import { render } from "./LipProfileWidget.vue?vue&type=template&id=2ac5c6a5&scoped=true&ts=true"
import script from "./LipProfileWidget.vue?vue&type=script&lang=ts"
export * from "./LipProfileWidget.vue?vue&type=script&lang=ts"

import "./LipProfileWidget.vue?vue&type=style&index=0&id=2ac5c6a5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ac5c6a5"]])

export default __exports__